<template>
  <div class="device015_dimming_wraper device_control_page_wraper">
    <div class="close_img_top">
      <img
        src="~assets/img/controlpublic/control-guanbi-chahao.png"
        @click="$closeControlToast"
        alt
      />
    </div>
    <div class="devce_name z_ellipsis1">{{objData.remark}}</div>

    <div class="content015_wraper content027_wraper">
      <!-- 控制按钮样式部分 -->
      <div class="device015_btn_wraper">
        <div class="one_btn_015_wraper" @click="device015BtnClickHandle(1)">开/升</div>
        <div class="one_btn_015_wraper" @click="device015BtnClickHandle(3)">停止</div>
        <div class="one_btn_015_wraper" @click="device015BtnClickHandle(2)">关/降</div>
      </div>
    </div>
    <!-- <BUtton @click="btnhandle">按钮</BUtton> -->
  </div>
</template>

<script>

// import { controlBtnRequestHandle } from "components/content/control-toast/control-toast-classify/device-public-js";
import {
  deviceTypeJudge,
  deviceTypeJudge1,
  publicDeviceTypeJudge,
  deviceStateFlip
} from "components/content/contro-view/device-view/device-item-view-js";

export default {
  data() {
    return {
      userControlData: this.objData
      // {
      //   ///用户设置的缓冲数据
      //   openState: this.objData.openState, ///1开 或 2关 3停 
      //   openStateValue: this.objData.openStateValue, //无用
      //   openStateValue1: this.objData.openStateValue1, ///无用
      //   openStateValue2: this.objData.openStateValue2 ///无用
      // }
    };
  },
  props: {
    objData: Object ///要控制设备的数据
  },
  methods: {
    device015BtnClickHandle(mode) {
      ///按钮按下
      this.userControlData.openState = mode;
      // controlBtnRequestHandle(this.userControlData, this.objData); ///控制请求服务端的公共方法
    },

    // btnhandle() {
    //   this.userControlData.openStateValue++;
    // }
  },
  computed: {

  },
  watch: {
    "objData.openState": {
      // deep:true,
      handler: function(val) {
        ///保证服务器数据和用户设置的数据同步
        console.log(val);
        this.userControlData.openState = val;
      }
    },

  }
};
</script>

<style>
.device015_dimming_wraper {
  height: 300px;
}

.content015_wraper{
  height: 180px;
  display: flex;
  justify-content: center;
  align-items: center;
}
/* 控制按钮样式部分 */
.device015_btn_wraper {
  width: 100%;
  height: 80px;

  display: flex;
  justify-content: space-around;
  align-items: center;
}
.one_btn_015_wraper {
  width: 80px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  /* border: 1px solid #f5f5f5; */
  border-radius: 4px;
  background-color: #f5f5f5;
  color: #282828;
}

.one_btn_015_wraper:active {
  background: #a0a3a5;
}
</style>
